import ExtendedTable from 'components/extendedTable/extended-table';
import TableWrapper from './TableWrapper';

// Wrap the ExtendedTable with state handlers
const List = TableWrapper(ExtendedTable);

export default List;
